import { useTranslation } from "react-i18next";
import Header from "../../../components/common/layout/Header";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import { Link } from "react-router-dom";
import { dataActions } from "../../../shared/store/data-Slice";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import CorporateHeader from "../../../components/common/layout/CorporateHeader";

const ScreenReaderAccess = ({ type }: any) => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    useSitemap();

    const data: any[] = [
        { id: 1, name: t("screen_reader.data.screen_access_for_all.name"), link: "http://safa.sourceforge.net/", type: t("screen_reader.data.screen_access_for_all.type") },
        { id: 2, name: t("screen_reader.data.non_visual.name"), link: "http://www.nvda-project.org/", type: t("screen_reader.data.non_visual.type") },
        { id: 3, name: t("screen_reader.data.system_access.name"), link: "http://www.satogo.com/", type: t("screen_reader.data.system_access.type") },
        { id: 4, name: t("screen_reader.data.web_anywhere.name"), link: "http://webanywhere.cs.washington.edu", type: t("screen_reader.data.web_anywhere.type") },
        { id: 5, name: t("screen_reader.data.hal.name"), link: "http://www.yourdolphin.co.uk/productdetail.asp?id=5", type: t("screen_reader.data.hal.type") },
        { id: 6, name: t("screen_reader.data.jaws.name"), link: "http://www.freedomscientific.com/jaws-hq.asp", type: t("screen_reader.data.supernova.type") },
        { id: 7, name: t("screen_reader.data.supernova.name"), link: "http://www.yourdolphin.co.uk/productdetail.asp?id=1", type: t("screen_reader.data.hal.type") },
        { id: 8, name: t("screen_reader.data.window_eyes.name"), link: "http://www.gwmicro.com/Window-Eyes/", type: t("screen_reader.data.window_eyes.type") }
    ];

    const handleLink = (item: any) => {
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(item));
    }

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.screen_reader_access.title")}</title>
                <meta name="description" content={t("seo_friendly.screen_reader_access.desc")} />
            </Helmet>
            <div className={`bg-white dark:bg-bgDarkDull ${type === "corporate" ? "mb-[30px] lg:mb-[50px]" : ""}`}>
                {type === "corporate" ?
                    <div className="w-full h-[240px] xlx:h-[315px] relative">
                        <div className="relative w-full h-full">
                            <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full" style={{ background: "linear-gradient(87deg, #162340 28%, rgba(22, 35, 64, 0.00) 94.38%)" }}></div>
                            <img src={require("../../../assets/images/pattern3.png")} alt="pattern" className="absolute top-0 left-0 bottom-0 z-[1] h-full" />
                            <img src={require("../../../assets/images/pages4.png")} alt="bg-image" className="w-full h-full object-cover" />
                        </div>
                        <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[58px] sm:pb-[45px] mms:pb-[40px] lgs:pb-[35px] xlx:pb-[60px] h-full z-[2]">
                            <div className="w-full h-fit">
                                <CorporateHeader bg={true} blur={true} />
                            </div>

                            <div className="flex container items-center justify-center mms:!px-[30px]">
                                <h2 className="text-white font-bold">{t("header.screen_reader_access")}</h2>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="w-full h-[240px] xlx:h-[285px] relative banner-bg">
                        <img src={theme === "dark" ? require("../../../assets/images/pages3.png") : require("../../../assets/images/pages.png")} alt="bg-image" className="w-full h-full object-cover" />
                        <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[25px] h-full">
                            <div className="w-full h-fit">
                                {type === "passenger" ? <Header type={type} /> : <RecruitmentHeader />}
                            </div>

                            <div className="flex container items-center justify-center md:!px-[30px] xlx:!px-[50px]">
                                <h2 className="text-primaryText dark:text-white font-bold">{t("header.screen_reader_access")}</h2>
                            </div>
                        </div>
                    </div>}
                <div className="container py-[40px] xlx:py-[60px] w-full" id="home">
                    <h5 className="text-blackDull dark:text-textBlackDull font-medium">{t("screen_reader.desc")}</h5>

                    <h5 className="text-blackDull dark:text-textBlackDull font-medium py-[25px]">{t("screen_reader.sub_desc")}</h5>

                    <div className="table-data ">
                        <div className="section">
                            <div className="subsection">
                                <div className="section-content">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="tbl-heading">{t("screen_reader.list.screen_reader")}</th>
                                                <th className="tbl-heading">{t("screen_reader.list.website")}</th>
                                                <th className="tbl-heading">{t("screen_reader.list.type")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(data) && data.map((item: any, index: number) => (
                                                <tr key={index}>
                                                    <td className="tbl-row whitespace-nowrap">{item?.name}</td>
                                                    <td className="tbl-row whitespace-nowrap"><Link to={item?.link} target="_blank" className="link" onClick={(e) => { handleLink(item?.link); e.preventDefault(); }}>{item?.link}</Link></td>
                                                    <td className="tbl-row whitespace-nowrap">{item?.type}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ScreenReaderAccess;